import { HellodialogClient } from "../../../../Shared/backendApi/hellodialog.generated";
import { extendedHttpResult } from "../../../../Shared/backendApi/utils";
const client = new HellodialogClient(window.location.origin);
const token = ()=>document.getElementsByName("__RequestVerificationToken")[0].value;
export const submitForm = (data)=>extendedHttpResult(()=>client.inschrijven(token(), toRequest(data)));
const toRequest = (data)=>{
    var _data_birthDate;
    return {
        email: data.emailAddress,
        voornaam: data.firstName,
        achternaam: data.lastName,
        geboortedatum: (_data_birthDate = data.birthDate) === null || _data_birthDate === void 0 ? void 0 : _data_birthDate.toLocaleDateString('en-CA'),
        groups: data.newsletters.toArray(),
        geslacht: null,
        _state: "Contact",
        _language: "NL"
    };
};
